export default process?.env?.VUE_APP_API_URL || ''

// export default 'https://staging.backend.sosplantao.com/api'
